<template>
  <Teleport :disabled="!isComponentActive" to="body">
    <div
      class="fixed pointer-events-none z-[9999] transition" 
      :class="[
        classes,
        isActive ? '' : 'opacity-0 translate-y-2', isLeft ? '' : '-translate-x-full'
      ]"
      :style="{
        top: (isActive ? mouseY - windowY : -9999) + 'px',
        left: (isActive ? mouseX : -9999) + 'px',
        [isFixed ? 'width' : 'maxWidth']: maxWidth + 'px'
      }"
      ref="$container"
    >
      <slot />
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
import WindowStore from '@/store/window'

const props = withDefaults(defineProps<{
  classes?: string
  isActive: boolean
  maxWidth?: number
  isFixed?: boolean
}>(), {
  classes: '',
  maxWidth: 360,
  isFixed: false
})

const $container = ref()

const windowStore = WindowStore()
const { mouseX, mouseY, windowY, windowWidth } = storeToRefs(windowStore)

const { width: elementSize } = useElementSize($container)

const isLeft = computed(() => mouseX.value < windowWidth.value - elementSize.value - 20)

const isComponentActive = ref(false)

const onStart = () => {
  isComponentActive.value = true
}

const onLeave = () => {
  isComponentActive.value = false
}

onActivated(() => {
  onStart()
})

onMounted(() => {
  onStart()
})

onDeactivated(() => {
  onLeave()
})

onBeforeUnmount(() => {
  onLeave()
})
</script>